import versionManagement from './service';
export default {
    versionManagement
};